import EmptyTableState from 'components/EmptyTableState';
import ListFooter from 'components/ListFooter';
import LoadingIndicator from 'components/LoadingIndicator';
import { resourceQueryParamName } from 'constants/resourceQueryNames';
import React from 'react';
import LoadingOverlay from 'react-loading-overlay-ts';
import { useSelector } from 'react-redux';

import { getActions, getActionsCount, getFetchCommentsLoading } from 'selectors/envelopeActions';
import CommentListRow from './CommentListRow';

const CommentsTable: React.FC = () => {
  const comments = useSelector(getActions);
  const loading = useSelector(getFetchCommentsLoading);
  const isEmpty = comments.length === 0;

  return (
    <>
      <div className="h-full flex flex-1 table-wrapper__new custom-scrollbar overflow-auto">
        <LoadingOverlay
          active={loading}
          spinner={<LoadingIndicator size="10" />}
          fadeSpeed={0}
          styles={{
            content: (base) => ({
              ...base,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }),
            wrapper: (base) => ({
              ...base,
              height: '100%',
            }),
            spinner: () => ({}),
            overlay: (base) => ({
              ...base,
              zIndex: 10,
            }),
          }}
        >
          <table className="table-wrapper__table table-wrapper_table--fixed">
            <thead className="sticky top-0 z-10">
              <tr>
                <th className="table-wrapper__new-th pl-6">Message</th>
                <th className="table-wrapper__new-th table-wrapper__th--w-18 leading-3">Date</th>
              </tr>
            </thead>
            <tbody className="table-wrapper__tbody">
              {isEmpty ? (
                <EmptyTableState message="There are no comments to display" colCount="2" />
              ) : (
                comments?.map((comment) => <CommentListRow comment={comment} key={comment.uuid} />)
              )}
            </tbody>
          </table>
        </LoadingOverlay>
      </div>
      <div className="w-full flex justify-center bg-white">
        <ListFooter
          resourceStateName={resourceQueryParamName.comments}
          resourceName="comment"
          getResourceList={getActions}
          getResourceTotalCount={getActionsCount}
          getResourceLoading={getFetchCommentsLoading}
        />
      </div>
    </>
  );
};

export default CommentsTable;
